module.exports = __webpack_public_path__ + "static/media/tree-removal.9d250329.jpg";